import { render, staticRenderFns } from "./HomeCloudEdit.vue?vue&type=template&id=20cfb646&scoped=true&"
import script from "./HomeCloudEdit.vue?vue&type=script&lang=js&"
export * from "./HomeCloudEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfb646",
  null
  
)

export default component.exports